<template>
  <div class="accidents">
    <div class="table table--inner">
      <div class="table__header table__header--inner">
        <div class="table__label table__label--large"> {{ $t('accidentsTables.caseOfficer') }}</div>
        <div class="table__label table__label--large"> {{ $t('accidentsTables.description') }}</div>
        <div class="table__label table__label--medium"> {{ $t('accidentsTables.amount') }}</div>
        <div class="table__label table__label--medium"> {{ $t('accidentsTables.status') }}</div>
        <div class="table__label table__label--large"> {{ $t('accidentsTables.actions') }}</div>
      </div>

      <div class="table__body">
        <Accident v-for="accident in accidents" :key="accident.id" :accident="accident"
          :openPolicyFilesModal="openPolicyFilesModal" />
      </div>
    </div>
  </div>
</template>

<script>
import Accident from "@/components/AccountDetails/Accident";
export default {
  name: "AccidentsTable",

  components: {
    Accident,
  },

  props: {
    accidents: {
      required: true,
      type: Array,
    },

    openPolicyFilesModal: {
      required: true,
      type: Function,
    },
  },
};
</script>
